import { handleSettledPromises } from '@kk/shared/utils/async';
import { assertParamsPrescence } from '@kk/shared/utils/validators';
import { useRouteLoaderData } from 'react-router';
import { assertNoLoaderErrors } from '#/api/errors';
import { fetchAnnualReportsQuery } from '#/api/hooks/useAnnualReports';
import type { InferLoaderData } from '#/routes/types';

export type LoaderData = InferLoaderData<typeof loader>;

export type Params = Record<string, string | undefined>;

export const id = 'annualReportsPage' as const;

async function loader({ params }: { params: Params }) {
  assertParamsPrescence(params);

  const data = await handleSettledPromises([fetchAnnualReportsQuery()]);

  assertNoLoaderErrors(id, data);

  const [annualReports] = data;

  return { annualReports };
}

export const useAnnualReportsPageLoaderData = () => useRouteLoaderData(id);
export default loader;
